import { render, staticRenderFns } from "./cascadeItem.vue?vue&type=template&id=15b94fb4&scoped=true"
import script from "./cascadeItem.vue?vue&type=script&lang=js"
export * from "./cascadeItem.vue?vue&type=script&lang=js"
import style0 from "./cascadeItem.vue?vue&type=style&index=0&id=15b94fb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b94fb4",
  null
  
)

export default component.exports